export const environment = {
  production: true,
  cookieDomain: 'folkelarsen.dk',
  formPost: 'https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8',
  salesForceID: '00D0Y000002Fyw5',
  GAid: 'UA-55569348-1'
};
